import { render } from "./MultiLanguageSelector.vue?vue&type=template&id=6954eb78"
import script from "./MultiLanguageSelector.vue?vue&type=script&lang=js"
export * from "./MultiLanguageSelector.vue?vue&type=script&lang=js"
script.render = render

export default script